import React, { useState } from "react";
import { useSystemTheme } from "../utils/useSystemTheme";
import { FiHeadphones } from "react-icons/fi";
import Lottie from "lottie-react";
import Login from "../screens/Login";

// Анимациялар
import animIntro from "../assets/animations/app_logo.json";
import android_anim from "../assets/animations/android.json";
import apple_anim from "../assets/animations/apple.json";

const WelcomeUI = () => {
    const theme = useSystemTheme();
    const [currentSlide, setCurrentSlide] = useState(0);

    // Құрылғы түрін анықтау
    const isAndroid = /Android/i.test(navigator.userAgent);
    // const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Слайдтар құрылғы түріне байланысты
    const slides = [
        {
            animation: animIntro,
            title: "Қош келдіңіз!",
            text: "Esti.kz — қазақ тіліндегі аудиокітаптарға арналған платформа. Тыңдаңыз, бөлісіңіз, сақтаңыз.",
        },
        {
            animation: isAndroid ? android_anim : apple_anim,
            title: "Қалай орнатуға болады?",
            text: isAndroid
                ? "Жоғарғы мәзірдегі үш нүктені басып, 'Қолданбаны орнату' таңдаңыз."
                : "Safari мәзірінен 'Бөлісу' түймесін басып, 'Басты экранға қосу' таңдаңыз.",
        },        
        {
            title: "Бастайық!",
            text: "Тіркеліп немесе кіріп, сүйікті кітаптарыңызды тыңдай беріңіз.",
        },
    ];

    // Тақырып және фон түстері
    const gradientClass =
        theme === "dark"
            ? "bg-gradient-to-tr from-[#1f2937] via-[#111827] to-[#0f172a]"
            : "bg-gradient-to-tr from-[#f0f4ff] via-[#e2f0ff] to-[#d0f0e8]";

    const textClass = theme === "dark" ? "text-white" : "text-gray-900";

    // Келесі батырмасы
    const handleNext = () => {
        setCurrentSlide((prev) => prev + 1);
    };

    return (
        <div className={`min-h-screen flex flex-col ${gradientClass}`}>
            {/* Header */}
            <header className="flex items-center justify-between px-6 py-4">
                <div className="flex items-center gap-2 text-blue-600 text-xl font-bold">
                    <FiHeadphones className="text-2xl" />
                    <span>Esti.kz</span>
                </div>
                {currentSlide < slides.length && (
                    <div className="text-sm font-medium text-gray-500">
                        {currentSlide + 1} / {slides.length + 1}
                    </div>
                )}
            </header>

            {/* Content */}
            <main className="flex-1 flex flex-col items-center justify-center px-6 text-center space-y-6">
                {currentSlide < slides.length ? (
                    <>
                        <Lottie
                            animationData={slides[currentSlide].animation}
                            autoplay
                            loop={false}
                            className="w-64 h-64"
                        />
                        <h1 className={`text-3xl font-bold ${textClass}`}>
                            {slides[currentSlide].title}
                        </h1>
                        <p className={`${textClass} text-lg max-w-xl`}>
                            {slides[currentSlide].text}
                        </p>
                    </>
                ) : (
                    <Login />
                )}
            </main>

            {/* Footer */}
            <footer className="px-6 py-4">
                {currentSlide <= slides.length - 1 && (
                    <button
                        onClick={handleNext}
                        className="w-full py-3 bg-blue-600 text-white font-semibold rounded-full hover:scale-105 transition"
                    >
                        {currentSlide === slides.length - 1 ? "Тіркелу / Кіру" : "Келесі"}
                    </button>
                )}
            </footer>
        </div>
    );
};

export default WelcomeUI;